module.exports = new __parcel__URL__("visa.2255752d.svg").toString();